import * as React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";
import { AboutDataContext } from "../pages/about/about";

const Partnership = () => {
  const {
    about_approach_partnership: {
      title,
      heading,
      button_text,
      button_link,
      description,
      image,
    },
  } = React.useContext(AboutDataContext);
  return (
    <section className="my-5 py-5 border-bottom" id="partnership">
      <div className="row">
        <div className="col-12 col-md-8 order-2 order-md-1">
          <h2 className="fs-32">{title}</h2>
          <h3 className="fs-24">{heading}</h3>
        </div>
        <div className="col-12 col-md-4 order-1 order-md-2">
          <img
            src={`${IMAGE_BASE_URL}/${image}`}
            alt="partnership"
            className="img-fluid d-block mx-auto mb-4"
          />
        </div>
      </div>
      <div
        className="mt-5 fs-16"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {/* <div>
        <LinkButton text={button_text} icon="&rarr;" path="" />
        <a
          className="fs-16 text-decoration-none btn-key-company d-inline-block cursor-pointer"
          href={button_link}
          target="_blank"
          rel="noreferrer"
        >
          <span className="text-spanish-gray">&rarr;</span>
          {"  "}
          <span className="gilroy-bold text-orange-ryb">{button_text}</span>
        </a>
      </div> */}
    </section>
  );
};

export default Partnership;
